
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-container">
      {/* Quick Links Section */}
      <div className="quick-links">
        <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
        <a href="/terms-of-service" className="footer-link">Terms of Service</a>
        <a href="/partner-program" className="footer-link">Partner Program</a>
        <a href="/contact-us" className="footer-link">Contact Us</a>
      </div>

      {/* Social Media Section */}
      <div className="social-media">
        <a
          href="https://linkedin.com" // Replace with actual LinkedIn link
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
          aria-label="LinkedIn"
        >
          <i className="fab fa-linkedin"></i>
        </a>
        <a
          href="https://twitter.com" // Replace with actual Twitter link
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
          aria-label="Twitter"
        >
          <i className="fab fa-twitter"></i>
        </a>
        <a
          href="https://youtube.com" // Replace with actual YouTube link
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
          aria-label="YouTube"
        >
          <i className="fab fa-youtube"></i>
        </a>
      </div>

      {/* Copyright Section */}
      <div className="copyright">
        © 2024 Ambivert AI. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;